let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2q4Ne")).then(() => parcelRequire('5jMKL'));